<template>
  <div>
    <div id="restaurant-tx-detail"></div>

    <div v-if="is_load" class="w-100 my-4 text-center">
      <loader />
    </div>
    <template v-else>
      <div class="p-4" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <div class="w-100">
          <!-- WAITING VIRTUAL ACCOUNT & QRIS -->
          <div class="px-4 py-5" v-if="trx.status == 'WAITING_PAYMENT'">
            <VirtualAccount
              v-if="
                trx.tx_payment_list[0].payment_channel.channel ==
                'VIRTUAL_ACCOUNT'
              "
              :data="trx.tx_payment_list[0]"
              :customer_detail="trx.session.customer_detail" />
            <Qris
              v-if="trx.tx_payment_list[0].payment_channel.channel == 'QRIS'"
              :data="trx.tx_payment_list[0]"
              :customer_detail="trx.session.customer_detail" />
            <div class="my-3 w-100 text-center">
              <p class="body-2-4 mb-2">
                {{ $t('hotel.waiting.already-made-a-payment') }}
              </p>
              <state-button
                size="lg"
                variant="primary"
                :click="loadDetailTrx"
                block
                >{{ $t('hotel.waiting.check-payment-status') }}</state-button
              >
            </div>
          </div>
          <template v-else>
            <div class="bg-white w-100" :class="showDeliveryTracking ? 'px-0' : 'px-4'" ref="receipt_wrapper">
              <!-- TRACK DELIVERY -->
              <DeliveryTrack v-if="showDeliveryTracking" ref="trackDelivery" :transaction-detail="trx" @updateDetail="updateDeliveryDetailData" />

              <!-- TOP SECTION -->
               <template v-else>
                 <div class="w-100 text-center top-section-wrapper">
                   <img v-if="trx.status === 'CANCELLED'" src="../../assets/img/icon/cancel-red.png" width="150" />
                   <img v-else src="../../assets/img/icon/new-success.png" width="150" />
                 </div>
                 <div
                   class="w-85 mx-auto text-center mb-4"
                   v-if="$isNotEmptyV2(generalLabel)">
                   <p 
                     class="mb-2 heading-5-1 text-32"
                     :class="trx.status === 'CANCELLED' ? 'text-danger' : 'text-success'"
                     >
                     {{ generalLabel.title }}
                   </p>
                   <p class="mb-3 body-1-2">{{ generalLabel.subtitle }}</p>
                   <div class="w-100 mb-3 border-form radius-6">
                     <div class="row no-gutters">
                       <div class="col-7">
                         <div class="py-2 border-r-form">
                           <p class="mb-0 body-3-3-1">Invoice</p>
                           <p class="mb-0 body-2-4 text-green">
                             {{ trx.invoice }}
                           </p>
                         </div>
                       </div>
                       <div class="col-5">
                         <div class="py-2">
                           <p class="mb-0 body-3-3-1">Total</p>
                           <p class="mb-0 body-2-4">
                             {{ $formatCurrency(trx.total_payment) }}
                           </p>
                         </div>
                       </div>
                     </div>
                   </div>
                   <p class="mb-4 body-2-2">{{ generalLabel.description }}</p>
   
                   <router-link
                     v-if="generalLabel.cta.type === 'homepage'"
                     :to="`/${getMerchant.code}`"
                     class="g-btn g-btn-primary g-btn-md px-4"
                     >{{ generalLabel.cta.title }}</router-link
                   >
                   <button
                     v-if="generalLabel.cta.type === 'track-order'"
                     class="g-btn g-btn-primary g-btn-md px-4"
                     @click="openTrackDelivery">
                     {{ generalLabel.cta.title }}
                   </button>
                 </div>
               </template>

              <div :class="!showDeliveryTracking ? 'px-0' : 'px-4 mt-4'">
                <!-- BOTTOM SECTION -->
                <div class="w-100 border-form box-shadow-light-aff p-3 radius-6 mb-4">
                  <!-- STATUS -->
                  <template v-if="!showDeliveryTracking">
                    <div
                      class="w-100 d-flex justify-content-between"
                      :class="{'cursor-pointer' : showRefreshButton}"
                      @click="refreshTrx()">
                      <div class="align-self-center">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_251_6)">
                            <path
                              d="M11.9941 23.9882C18.5556 23.9882 23.9882 18.5439 23.9882 11.9941C23.9882 5.43262 18.5439 0 11.9823 0C5.43262 0 0 5.43262 0 11.9941C0 18.5439 5.44438 23.9882 11.9941 23.9882ZM11.9941 21.9892C6.4439 21.9892 2.01078 17.5443 2.01078 11.9941C2.01078 6.4439 6.43214 1.99902 11.9823 1.99902C17.5326 1.99902 21.9892 6.4439 21.9892 11.9941C21.9892 17.5443 17.5443 21.9892 11.9941 21.9892Z"
                              fill="black"
                              fill-opacity="0.85" />
                            <path
                              d="M5.8442 13.2642H11.9823C12.4409 13.2642 12.8055 12.9114 12.8055 12.4409V4.51546C12.8055 4.05687 12.4409 3.7041 11.9823 3.7041C11.5238 3.7041 11.171 4.05687 11.171 4.51546V11.6296H5.8442C5.37384 11.6296 5.02107 11.9824 5.02107 12.4409C5.02107 12.9114 5.37384 13.2642 5.8442 13.2642Z"
                              fill="black"
                              fill-opacity="0.85" />
                          </g>
                          <defs>
                            <clipPath id="clip0_251_6">
                              <rect width="23.9882" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="align-self-center w-85">
                        <p class="mb-0 body-2-4">{{ statusText }}</p>
                        <p class="mb-0 body-3" v-if="showRefreshButton">Click here to check for updates</p>
                      </div>
                    </div>
                    <div class="my-3 border-b-form-dashed-2"></div>
                  </template>
  
                  <!-- DETAIL -->
                  <div
                    class="w-100 d-flex justify-content-between"
                    @click="toggleDetail()">
                    <div class="align-self-center">
                      <svg
                        width="27"
                        height="24"
                        viewBox="0 0 27 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_758_35)">
                          <path
                            d="M13.6475 19.5787H25.4131C25.9053 19.5787 26.3154 19.1919 26.3154 18.6997C26.3154 18.1958 25.9053 17.8091 25.4131 17.8091H13.6475C13.1553 17.8091 12.7568 18.1958 12.7568 18.6997C12.7568 19.1919 13.1553 19.5787 13.6475 19.5787Z"
                            fill="black"
                            fill-opacity="0.85" />
                          <path
                            d="M5.09277 23.7505C7.84668 23.7505 10.1436 21.4654 10.1436 18.7115C10.1436 15.9341 7.84668 13.6373 5.09277 13.6373C2.32715 13.6373 0.0419922 15.9341 0.0419922 18.7115C0.0419922 21.4654 2.33887 23.7505 5.09277 23.7505ZM4.49511 21.4185C4.24902 21.4185 4.08496 21.2779 3.90918 21.0904L2.59668 19.4966C2.47949 19.3677 2.44433 19.2271 2.44433 19.0396C2.44433 18.6997 2.70215 18.4419 3.01855 18.4419C3.24121 18.4419 3.40527 18.524 3.55761 18.7349L4.47168 19.8951L6.55761 16.5435C6.69824 16.3208 6.87402 16.2037 7.08496 16.2037C7.41308 16.2037 7.69433 16.4615 7.69433 16.7662C7.69433 16.9302 7.64746 17.0591 7.54199 17.2349L5.09277 21.0787C4.96387 21.3013 4.75293 21.4185 4.49511 21.4185Z"
                            fill="black"
                            fill-opacity="0.85" />
                          <path
                            d="M13.6475 6.03174H25.4131C25.9053 6.03174 26.3154 5.64502 26.3154 5.14112C26.3154 4.64893 25.9053 4.26221 25.4131 4.26221H13.6475C13.1553 4.26221 12.7568 4.64893 12.7568 5.14112C12.7568 5.64502 13.1553 6.03174 13.6475 6.03174Z"
                            fill="black"
                            fill-opacity="0.85" />
                          <path
                            d="M5.09277 10.1802C7.84668 10.1802 10.1436 7.89502 10.1436 5.14112C10.1436 2.37549 7.84668 0.0786133 5.09277 0.0786133C2.32715 0.0786133 0.0419922 2.37549 0.0419922 5.14112C0.0419922 7.89502 2.33887 10.1802 5.09277 10.1802ZM4.49511 7.84815C4.24902 7.84815 4.08496 7.71924 3.90918 7.52002L2.59668 5.93799C2.47949 5.80908 2.44433 5.66846 2.44433 5.48096C2.44433 5.14112 2.70215 4.87158 3.01855 4.87158C3.24121 4.87158 3.40527 4.96534 3.55761 5.16455L4.47168 6.32471L6.55761 2.97315C6.69824 2.76221 6.87402 2.64502 7.08496 2.64502C7.41308 2.64502 7.69433 2.90284 7.69433 3.1958C7.69433 3.35987 7.64746 3.50049 7.54199 3.67627L5.09277 7.52002C4.96387 7.73096 4.75293 7.84815 4.49511 7.84815Z"
                            fill="black"
                            fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_758_35">
                            <rect
                              width="26.2734"
                              height="23.707"
                              fill="white"
                              transform="translate(0.0419922 0.043457)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="align-self-center w-85">
                      <div class="d-flex justify-content-between">
                        <div class="align-self-center w-80">
                          <p class="mb-0 body-2-4">Order Details</p>
                          <p class="mb-0 body-3">Items, pricing, and notes</p>
                        </div>
                        <div class="align-self-center">
                          <svg
                            width="12"
                            height="21"
                            viewBox="0 0 12 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_572_18)">
                              <path
                                d="M11.4609 10.1719C11.4609 9.87891 11.3438 9.60938 11.1211 9.39844L1.83984 0.304688C1.62891 0.105469 1.37109 0 1.06641 0C0.46875 0 0 0.457031 0 1.06641C0 1.35938 0.117188 1.62891 0.304688 1.82812L8.83594 10.1719L0.304688 18.5156C0.117188 18.7148 0 18.9727 0 19.2773C0 19.8867 0.46875 20.3438 1.06641 20.3438C1.37109 20.3438 1.62891 20.2383 1.83984 20.0273L11.1211 10.9453C11.3438 10.7227 11.4609 10.4648 11.4609 10.1719Z"
                                fill="#222222" />
                            </g>
                            <defs>
                              <clipPath id="clip0_572_18">
                                <rect
                                  width="11.4609"
                                  height="20.3555"
                                  fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <!-- DELIVERY -->
                  <template v-if="trx.order_type == 'DELIVERY'">
                    <div class="my-3 border-b-form-dashed-2"></div>
                    <div
                      class="w-100 d-flex justify-content-between"
                      @click="toggleDetailDelivery()">
                      <div class="align-self-center">
                        <svg
                          width="24"
                          height="26"
                          viewBox="0 0 24 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_757_27)">
                            <path
                              d="M1.64062 20.2852L10.8633 25.5117C11.5195 25.8867 12.1406 25.8867 12.8086 25.5117L22.0195 20.2852C23.0977 19.6758 23.6602 19.0547 23.6602 17.3789V8.09766C23.6602 6.87891 23.2148 6.11719 22.2305 5.55469L13.9336 0.84375C12.5156 0.0351562 11.1445 0.0351562 9.72656 0.84375L1.44141 5.55469C0.445312 6.11719 0 6.87891 0 8.09766V17.3789C0 19.0547 0.574219 19.6758 1.64062 20.2852ZM2.69531 18.7383C2.01562 18.3633 1.78125 17.9648 1.78125 17.3203V8.47266L10.9102 13.6875V23.4141L2.69531 18.7383ZM20.9766 18.7383L12.75 23.4141V13.6875L21.8789 8.47266V17.3203C21.8789 17.9648 21.6445 18.3633 20.9766 18.7383ZM11.8359 12.0469L2.78906 6.92578L6.41016 4.85156L15.457 9.99609L11.8359 12.0469ZM17.3438 8.92969L8.26172 3.79688L10.5117 2.51953C11.4141 2.00391 12.2461 1.99219 13.1602 2.51953L20.8828 6.92578L17.3438 8.92969Z"
                              fill="black"
                              fill-opacity="0.85" />
                          </g>
                          <defs>
                            <clipPath id="clip0_757_27">
                              <rect
                                width="23.6602"
                                height="25.793"
                                fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="align-self-center w-85">
                        <div class="d-flex justify-content-between">
                          <div class="align-self-center w-80">
                            <p class="mb-0 body-2-4">Delivery Info</p>
                            <p class="mb-0 body-3">Details about your delivery</p>
                          </div>
                          <div class="align-self-center">
                            <svg
                              width="12"
                              height="21"
                              viewBox="0 0 12 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_572_18)">
                                <path
                                  d="M11.4609 10.1719C11.4609 9.87891 11.3438 9.60938 11.1211 9.39844L1.83984 0.304688C1.62891 0.105469 1.37109 0 1.06641 0C0.46875 0 0 0.457031 0 1.06641C0 1.35938 0.117188 1.62891 0.304688 1.82812L8.83594 10.1719L0.304688 18.5156C0.117188 18.7148 0 18.9727 0 19.2773C0 19.8867 0.46875 20.3438 1.06641 20.3438C1.37109 20.3438 1.62891 20.2383 1.83984 20.0273L11.1211 10.9453C11.3438 10.7227 11.4609 10.4648 11.4609 10.1719Z"
                                  fill="#222222" />
                              </g>
                              <defs>
                                <clipPath id="clip0_572_18">
                                  <rect
                                    width="11.4609"
                                    height="20.3555"
                                    fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="my-3 border-b-form-dashed-2"></div>
  
                  <!-- PAYMENT -->
                  <div class="w-100 d-flex justify-content-between">
                    <div class="align-self-center">
                      <svg
                        width="28"
                        height="21"
                        viewBox="0 0 28 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_758_31)">
                          <path
                            d="M5.26172 15.9258H8.13281C8.82422 15.9258 9.28125 15.457 9.28125 14.8008V12.6328C9.28125 11.9648 8.82422 11.5078 8.13281 11.5078H5.26172C4.57031 11.5078 4.11328 11.9648 4.11328 12.6328V14.8008C4.11328 15.457 4.57031 15.9258 5.26172 15.9258ZM0.949219 7.33594H26.6016V4.67578H0.949219V7.33594ZM3.67969 20.0273H23.8594C26.3203 20.0273 27.5391 18.8203 27.5391 16.4062V3.64453C27.5391 1.23047 26.3203 0.0117188 23.8594 0.0117188H3.67969C1.23047 0.0117188 0 1.23047 0 3.64453V16.4062C0 18.8203 1.23047 20.0273 3.67969 20.0273ZM3.70312 18.1406C2.53125 18.1406 1.88672 17.5195 1.88672 16.3008V3.75C1.88672 2.53125 2.53125 1.89844 3.70312 1.89844H23.8359C24.9844 1.89844 25.6523 2.53125 25.6523 3.75V16.3008C25.6523 17.5195 24.9844 18.1406 23.8359 18.1406H3.70312Z"
                            fill="black"
                            fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_758_31">
                            <rect width="27.5391" height="20.0273" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="align-self-center w-85">
                      <div
                        class="d-flex justify-content-between"
                        @click="toggleDetailPayment()">
                        <div class="align-self-center w-80">
                          <p class="mb-0 body-2-4">Payment Details</p>
                          <p
                            class="mb-0 body-3"
                            v-if="payment.status != 'PAY_LATER'">
                            How you paid and its status
                          </p>
                          <p class="mb-0 body-3" v-else>
                            This order uses <b>pay later</b>
                          </p>
                        </div>
                        <div
                          class="align-self-center"
                          v-if="payment.status != 'PAY_LATER'">
                          <svg
                            width="12"
                            height="21"
                            viewBox="0 0 12 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_572_18)">
                              <path
                                d="M11.4609 10.1719C11.4609 9.87891 11.3438 9.60938 11.1211 9.39844L1.83984 0.304688C1.62891 0.105469 1.37109 0 1.06641 0C0.46875 0 0 0.457031 0 1.06641C0 1.35938 0.117188 1.62891 0.304688 1.82812L8.83594 10.1719L0.304688 18.5156C0.117188 18.7148 0 18.9727 0 19.2773C0 19.8867 0.46875 20.3438 1.06641 20.3438C1.37109 20.3438 1.62891 20.2383 1.83984 20.0273L11.1211 10.9453C11.3438 10.7227 11.4609 10.4648 11.4609 10.1719Z"
                                fill="#222222" />
                            </g>
                            <defs>
                              <clipPath id="clip0_572_18">
                                <rect
                                  width="11.4609"
                                  height="20.3555"
                                  fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div
                  class="w-100 text-center mb-5"
                  v-if="$isNotEmpty(getMerchant.whatsapp_number)">
                  <p class="mb-2 body-2-1">Need Help?</p>
                  <button
                    class="g-btn g-btn-wa g-btn-lg w-100"
                    @click="goToWaChat()">
                    <svg
                      class="lh-1 mr-2"
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.5487 4.25C9.16775 4.25 3.97475 9.25175 3.9725 15.3988C3.971 17.3645 4.505 19.283 5.5175 20.9728L3.875 26.75L10.0122 25.1998C11.7194 26.0928 13.6176 26.5586 15.5442 26.5573H15.5487C21.9297 26.5573 27.1227 21.5548 27.125 15.4078C27.1265 12.4303 25.9235 9.6275 23.7372 7.52075C21.5517 5.41325 18.6455 4.25075 15.5487 4.25ZM15.5487 24.674H15.545C13.8185 24.674 12.125 24.227 10.6475 23.3825L10.295 23.1815L6.6545 24.101L7.6265 20.681L7.39775 20.3308C6.43693 18.8654 5.92545 17.151 5.92625 15.3988C5.9285 10.289 10.2455 6.13325 15.5525 6.13325C18.122 6.134 20.5377 7.09925 22.355 8.8505C24.1722 10.6018 25.172 12.9305 25.1705 15.407C25.1682 20.5168 20.852 24.674 15.548 24.674H15.5487ZM20.8265 17.7328C20.537 17.594 19.115 16.9198 18.8495 16.826C18.5847 16.7338 18.392 16.6858 18.1992 16.9648C18.0072 17.2438 17.4522 17.8715 17.2842 18.0568C17.1147 18.2428 16.946 18.2653 16.6565 18.1265C16.367 17.987 15.4347 17.693 14.3307 16.7435C13.4705 16.0055 12.89 15.0935 12.7212 14.8138C12.5525 14.5355 12.7032 14.3848 12.848 14.246C12.9777 14.1223 13.1375 13.9213 13.2815 13.7585C13.4255 13.5958 13.4735 13.4795 13.571 13.2935C13.667 13.1083 13.619 12.9448 13.5462 12.806C13.4735 12.6658 12.896 11.2948 12.6537 10.7375C12.4197 10.1945 12.1812 10.2673 12.0035 10.2583C11.8347 10.2508 11.6427 10.2485 11.4485 10.2485C11.2572 10.2485 10.943 10.3183 10.6775 10.5973C10.4127 10.8763 9.665 11.5498 9.665 12.9208C9.665 14.2925 10.7015 15.617 10.8462 15.803C10.991 15.9883 12.8862 18.803 15.788 20.0105C16.478 20.2963 17.0165 20.468 17.4372 20.597C18.1302 20.8093 18.761 20.7785 19.259 20.7073C19.814 20.627 20.9705 20.0338 21.2105 19.3835C21.452 18.7333 21.452 18.1753 21.38 18.059C21.3095 17.9428 21.116 17.873 20.8265 17.7328V17.7328Z"
                        fill="white" />
                    </svg>
                    <span class="lh-1 position-relative" style="top: 2px">
                      Chat with us
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- DETAIL ORDER -->
        <popup-detail
          id_ref="trx_detail"
          direction="bottom"
          :show="show_detail"
          use_max_size
          wrapper_size="mobile"
          use_footer
          @close="toggleDetail">
          <template v-slot:body>
            <div class="p-4">
              <!-- HEADER -->
              <div class="row">
                <div class="col-6">
                  <p class="mb-0 body-3">Invoice</p>
                  <p class="mb-0 body-2-4">{{ trx.invoice }}</p>
                </div>
                <div class="col-6">
                  <p class="mb-0 body-3">Transaction Date</p>
                  <p class="mb-0 body-2-4">
                    {{ $formatDateTime(trx.service_date) }}
                  </p>
                </div>
                <div class="col-12 my-3">
                  <div class="w-100 border-b-semi-grey-dashed"></div>
                </div>
              </div>

              <!-- PRODUCT -->
              <div class="w-100">
                <div
                  class="w-100 d-flex"
                  :class="{
                    'mb-3 pb-3 border-b-semi-grey-dashed-2':
                      index + 1 < trx.tx_detail_list.length,
                  }"
                  v-for="(product, index) in trx.tx_detail_list"
                  :key="index">
                  <div class="align-self-start pr-3">
                    <div
                      class="position-relative radius-6 p-2 lh-1 border-green">
                      <p
                        class="text-14 mb-0 text-center font-lato w-100 lh-1 z-index-1026">
                        {{ product.qty }}x
                      </p>
                      <div class="primary-overlay radius-6 z-index-1025"></div>
                    </div>
                  </div>
                  <div
                    class="align-self-start w-100 d-flex justify-content-between">
                    <div class="pr-3">
                      <p class="body-2-1 mb-0">
                        {{ product.product_full_name }}
                      </p>
                      <p v-if="product.notes != null" class="mb-0 body-3-3-1">
                        Note : <b>{{ product.notes }}</b>
                      </p>
                      <p class="mb-0 text-14 font-lato">
                        {{ $formatCurrency(product.price_sell) }}
                      </p>
                    </div>
                    <div style="width: 70px; height: 70px; flex-shrink: 0">
                      <img
                        :src="product.product_image"
                        class="img-fit radius-6" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="w-100 my-4"
                style="height: 8px; background-color: #eee"></div>

              <!-- PRICE DETAIL -->
              <div class="w-100">
                <div class="row slim-grid-row mb-2">
                  <div class="col-7 align-self-center">
                    <p class="mb-0 body-2-1">
                      {{ $t('hotel.concierge.sub-total') }}
                    </p>
                  </div>
                  <div class="col-5 text-right align-self-center">
                    <p class="mb-0 font-lato text-14">
                      {{ $formatCurrency(trx.total_amount) }}
                    </p>
                  </div>
                </div>
                <div class="row slim-grid-row mb-2">
                  <div class="col-7 align-self-center">
                    <p class="mb-0 body-2-1">
                      {{ $t('hotel.concierge.discount') }}
                    </p>
                  </div>
                  <div class="col-5 text-right align-self-center">
                    <p
                      v-if="Math.abs(parseFloat(trx.total_discount)) > 0"
                      class="mb-0 font-lato text-14 text-green">
                      -
                      {{
                        $formatCurrency(
                          Math.abs(parseFloat(trx.total_discount))
                        )
                      }}
                    </p>
                    <p v-else class="mb-0 font-lato text-14">
                      {{
                        $formatCurrency(
                          Math.abs(parseFloat(trx.total_discount))
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col-6">
                    <p class="mb-0 body-2-1">
                      {{ $t('hotel.concierge.tax-service') }}
                    </p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-1">
                      {{
                        $formatCurrency(
                          parseFloat(trx.total_taxes) +
                            parseFloat(trx.total_service)
                        )
                      }}
                    </p>
                  </div>
                </div>
                <template v-if="trx.order_type == 'DELIVERY'">
                  <div class="row no-gutters mt-2">
                    <div class="col-6">
                      <p class="mb-0 body-2-1">Delivery Fee</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-2-1">
                        {{ $formatCurrency(parseFloat(trx.total_delivery)) }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="row no-gutters mt-2"
                    v-if="trx.delivery && trx.delivery.packaging_fee">
                    <div class="col-6">
                      <p class="mb-0 body-2-1">Packaging Fee</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-2-1">
                        {{
                          $formatCurrency(
                            parseFloat(trx.delivery.packaging_fee)
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </template>
                <div class="border-b-semi-grey-dashed-2 w-100 my-3"></div>
                <div class="row slim-grid-row" id="for-payment-section">
                  <div class="col-6">
                    <p class="mb-0 body-1-4">Total</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 font-lato text-16">
                      {{ $formatCurrency(trx.total_payment) }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- NOTES -->
              <template v-if="$isNotEmpty(trx.notes)">
                <div
                  class="w-100 my-4"
                  style="height: 8px; background-color: #eee"></div>
                <div class="w-100 radius-6 border-semi-grey p-3">
                  <p class="mb-0 body-2-4 w-100">Notes</p>
                  <p class="mb-0 body-2-2">{{ trx.notes }}</p>
                </div>
              </template>
            </div>
          </template>
          <template v-slot:footer>
            <div class="px-3 pt-4">
              <button @click="toggleDetail" class="ga-btn-primary-lg">
                Close
              </button>
            </div>
          </template>
        </popup-detail>

        <!-- DETAIL DELIVERY -->
        <popup-detail
          id_ref="trx_detail_payment"
          direction="bottom"
          :show="delivery.show"
          use_max_size
          title="Delivery Detail"
          wrapper_size="mobile"
          @close="toggleDetailDelivery">
          <template slot="body">
            <div class="w-100" v-if="delivery.show && trx.status !== 'COMPLETE'">
              <gmap-map
                :center="delivery.map.center"
                :options="delivery.map_config"
                :zoom="15"
                style="width: 100%; height: 200px"
                :draggable="false">
                <gmap-marker
                  :position="delivery.map.markers.position"
                  :draggable="false"></gmap-marker>
              </gmap-map>
            </div>
            
            <DeliveryTrack 
              v-if="deliveryCompany === 'BITESHIP' && trx.status === 'COMPLETE' && $isNotEmptyV2(deliveryDetail)" 
              ref="trackDeliveryPopup" 
              :transaction-detail="trx" />

            <div class="p-4 mb-4">
              <div class="pb-3 mb-3 border-b-form-dashed-2">
                <div class="w-100 mb-3">
                  <p class="mb-0 body-3-3-1">Full Address</p>
                  <p class="mb-0 body-2-1">
                    {{ delivery.data.destination_text }}
                  </p>
                </div>
                <div
                  class="w-100 mb-3"
                  v-if="$isNotEmpty(delivery.data.destination_landmark)">
                  <p class="mb-0 body-3-3-1">Landmark</p>
                  <p class="mb-0 body-2-1">
                    {{ delivery.data.destination_landmark }}
                  </p>
                </div>
              </div>
              <div class="w-100">
                <div
                  class="w-100 mb-3 pb-3 border-b-form-dashed-2 d-flex justify-content-between">
                  <p class="mb-0 body-2-1">Delivery Fee</p>
                  <p class="mb-0 font-lato text-14">
                    {{ $formatCurrency(delivery.data.delivery_fee) }}
                  </p>
                </div>
                <div
                  class="w-100 mb-3 pb-3 border-b-form-dashed-2 d-flex justify-content-between">
                  <p class="mb-0 body-2-1">Distance</p>
                  <p class="mb-0 font-lato text-14">
                    {{ delivery.data.distance_text }}
                  </p>
                </div>
                <div class="w-100 d-flex justify-content-between">
                  <p class="mb-0 body-2-1">Estimated delivery time</p>
                  <p class="mb-0 font-lato text-14">
                    {{ delivery.data.duration_text }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </popup-detail>

        <!-- DETAIL PAYMENT -->
        <popup-detail
          id_ref="trx_detail_payment"
          direction="bottom"
          :show="show_detail_payment"
          use_max_size
          title="Payment Detail"
          wrapper_size="mobile"
          @close="toggleDetailPayment">
          <template slot="body">
            <div class="p-4 border-t-form">
              <div class="w-100 border-semi-grey radius-12 p-3 mb-4">
                <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
                  <div class="col-6">
                    <p class="body-2-2-1 mb-0">Invoice Number</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="body-2-1 mb-0">{{ trx.invoice }}</p>
                  </div>
                </div>
                <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
                  <div class="col-6">
                    <p class="body-2-2-1 mb-0">Payment Method</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="body-2-1 mb-0">{{ payment.payment_name }}</p>
                  </div>
                </div>
                <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
                  <div class="col-6">
                    <p class="body-2-2-1 mb-0">Status</p>
                  </div>
                  <div class="col-6 text-right">
                    <p
                      class="body-2-1 mb-0 text-uppercase"
                      :class="
                        payment.status == 'SUCCESS'
                          ? 'text-success'
                          : 'text-danger'
                      ">
                      {{ payment.status }}
                    </p>
                  </div>
                </div>
                <div class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
                  <div class="col-6">
                    <p class="body-2-2-1 mb-0">Date</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="body-2-1 mb-0">
                      {{ $formatDateTime(payment.created_at) }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="Number(payment_surcharge) > 0"
                  class="row no-gutters pb-2 mb-2 border-b-semi-grey-dashed">
                  <div class="col-6">
                    <p class="body-2-2-1 mb-0">Payment Surcharge</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="body-2-1 mb-0">
                      {{ $formatCurrency(payment_surcharge) }}
                    </p>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col-6">
                    <p class="body-2-2-1 mb-0">Total Paid</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="body-2-1 mb-0">
                      {{ $formatCurrency(total_payment) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </popup-detail>
      </template>
    </template>
  </div>
</template>
<script>
import { get } from '@/services/index.js';
import { mapGetters } from 'vuex';
import VirtualAccount from '@/components/general/payment/VirtualAccount';
import Qris from '@/components/general/payment/Qris';
import DeliveryTrack from '../../components/general/DeliveryTrack.vue';

export default {
  components: {
    VirtualAccount,
    Qris,
    DeliveryTrack,
  },
  data() {
    return {
      is_load: true,
      is_reload: false,
      error: '',
      trx: {},
      payment: {},
      show_detail: false,
      show_detail_payment: false,
      delivery: {
        show: false,
        map_config: {
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          panControl: false,
          rotateControl: false,
          scaleControl: false,
          gestureHandling: 'none',
        },
        map: {
          center: { lat: null, lng: null },
          markers: {},
        },
        data: {},
      },
      deliveryDetail: null
    };
  },
  computed: {
    ...mapGetters(['getMerchant']),
    tx_id() {
      return this.$route.params.trx_id;
    },
    totalQtyOrder() {
      let total = 0;
      if (this.trx.id) {
        this.trx.tx_detail_list.map((x) => (total += x.qty));
      }
      return total;
    },
    payment_surcharge() {
      let total = 0;

      if (this.trx.id && this.trx.tx_payment_list.length > 0) {
        let payment_obj = this.trx.tx_payment_list[0].payment_channel;
        if (payment_obj.surcharge_type == 'PERCENT') {
          total =
            (parseFloat(this.trx.total_payment) / 100) *
            payment_obj.surcharge_value;
        } else {
          total = payment_obj.surcharge_value;
        }
      }

      return total;
    },
    total_payment() {
      let total = 0;
      if (this.trx.id) {
        total = parseFloat(this.trx.total_payment) + this.payment_surcharge;
      }
      return total;
    },
    statusText() {
      if (this.$isEmpty(this.trx)) return 'Loading...';
      switch (this.trx.status) {
        case 'PENDING':
          return 'Restaurant is reviewing your order';
        case 'ONPROGRESS':
          return 'Your order is in the kitchen!';
        case 'WAITING_PAYMENT':
          return 'Waiting your payment';
        case 'COMPLETE':
          return 'Your order is served';
        case 'CANCELLED':
          return 'Your order is cancelled';
        default:
          return '';
      }
    },
    generalLabel() {
      if (this.$isEmpty(this.trx)) return null;

      const { session: { customer_detail: { name: guestName } }, order_type, delivery, status } = this.trx;
      
      let text = {
        title: 'Success!',
        subtitle: `Hey ${guestName}, your order is confirmed!`,
        description:
          "Sit tight, we're on it! Your delicious food is on the way.",
        cta: {
          title: 'Explore Other Menu',
          type: 'homepage',
        },
      };

      if(status === 'CANCELLED'){
        text = {
          title: 'Cancelled!',
          subtitle: `Your order has been cancelled.`,
          description:
            "Sorry, your order was cancelled. You can reorder or contact support anytime.",
          cta: {
            title: 'Reorder Now',
            type: 'homepage',
          },
        }
        
        return text;
      }
      
      if (order_type === 'DELIVERY') {
        text.title = 'Order Confirmed!';
        text.subtitle = `Hey ${guestName}, we've confirmed your delivery order.`;
        text.description =
          'Your meal is being prepared. We’ll let you know once it’s on the move!';

        if (
          delivery.delivery_company === 'BITESHIP' &&
          status === 'ONPROGRESS'
        ) {
          text.cta = {
            title: 'Track Your Order',
            type: 'track-order',
          };
        }
      }

      return text;
    },
    deliveryCompany(){
      if(this.$isEmpty(this.trx)) return "";

      const { order_type, delivery } = this.trx
      
      if(order_type === "DINE_IN" || this.$isEmpty(delivery)) return "";

      return this.$isEmpty(delivery.delivery_company) ? "MERCHANT" : delivery.delivery_company
    },
    showRefreshButton(){
      if(this.$isEmpty(this.trx)) return false;
      const { status } = this.trx;
      const allowedStatus = ['PENDING', 'ONPROGRESS', 'WAITING_PAYMENT']
      return allowedStatus.some(sts => sts === status);
    },
    showDeliveryTracking(){
      return this.deliveryCompany === 'BITESHIP' && this.trx.status === 'ONPROGRESS' && this.$isNotEmptyV2(this.deliveryDetail)
    }
  },
  mounted() {
    this.$smoothScroll('restaurant-tx-detail');
    this.firstLoadData();
  },
  methods: {
    updateDeliveryDetailData(data){
      this.deliveryDetail = data;
    },
    refreshTrx(){
      if(!this.showRefreshButton) return;
      this.firstLoadData()
    },
    firstLoadData() {
      this.is_load = true;
      this.error = '';
      this.loadDetailTrx()
        .catch((err) => (this.error = err))
        .finally(() => (this.is_load = false));
    },
    loadDetailTrx() {
      return new Promise((success, fail) => {
        get('CORE_RESTO', `v2/tx-history/${this.tx_id}`, {
          merchant_id: this.getMerchant.id,
        }).then((response) => {
          let res = response.data;
          if (res.success) {
            this.trx = res.data;
            this.setupData(res.data);
            if(this.deliveryCompany === 'BITESHIP' && (this.trx.status === 'ONPROGRESS' || this.trx.status === 'COMPLETE')) this.getDetailDelivery();
            success(res.message);
          } else {
            fail(res.message);
          }
        });
      });
    },
    setupData(data) {
      this.trx.tx_detail_list = this.trx.tx_detail_list.map((x) => {
        x.product_full_name =
          x.variant_id != null
            ? `${x.variant_name} - ${x.product_name}`
            : x.product_name;
        return x;
      });
      if (this.trx.order_type == 'DELIVERY') {
        let del = this.trx.delivery;
        this.delivery.data = del;
        this.delivery.map = {
          center: {
            lat: del.destination_position[0],
            lng: del.destination_position[1],
          },
          markers: {
            position: {
              lat: del.destination_position[0],
              lng: del.destination_position[1],
            },
          },
        };
      }
      this.getDetailPayment(data.tx_payment_list);
    },
    async getDetailDelivery() {
      try {

        const apiPath = `v2/tx-history/${this.trx.id}/delivery`;
        const apiResponse = await get('CORE_RESTO', apiPath, {
          merchant_id: this.getMerchant.id,
        });

        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);

        this.deliveryDetail = data  ? this.parsedDetailDelivery(data) : null;
      } catch (error) {
        throw error;
      }
    },
    parsedDetailDelivery(deliveryDetail) {
      let deliveryParsed = deliveryDetail;
      deliveryParsed.history = deliveryDetail.history
        .map((delivery) => {
          delivery.description = this.$parsingDeliveryStatus(
            delivery.status,
            delivery.currentNote
          );
          return delivery;
        })
        .reverse();
      return deliveryParsed;
    },
    goToHome() {
      this.$router.push(`/${this.getMerchant.code}`);
    },
    toggleDetail() {
      this.show_detail = !this.show_detail;
    },
    toggleDetailPayment() {
      if (this.payment.status != 'PAY_LATER') {
        this.show_detail_payment = !this.show_detail_payment;
      }
    },
    toggleDetailDelivery() {
      this.delivery.show = !this.delivery.show;
    },
    downloadStruk() {
      return new Promise((success, fail) => {
        let file_name = `${this.trx.invoice} - ${this.getMerchant.name}`;
        this.$domToImg(this.$refs.receipt_wrapper, file_name).finally(() => {
          success();
        });
      });
    },
    getDetailPayment(payment) {
      if (payment.length == 0) {
        this.payment.status = 'PAY_LATER';
      } else {
        let clone_data = this.$deepCopy(payment[0].tx_bill_payment);
        this.payment = {
          status: clone_data.status,
          bank_name: clone_data.payment_channel.payment_gateway.pg_company,
          pg_mode: clone_data.payment_channel.payment_gateway.pg_mode,
          payment_method: clone_data.payment_channel.channel,
          payment_name: clone_data.payment_channel.name,
          pg_response: clone_data.inq_resp_detail,
          created_at: payment[0].created_at,
          detail: clone_data,
          payment_detail_error: clone_data.pay_resp_detail,
        };
      }
    },
    maskingPlusChar(data) {
      let return_data = data.substring(0, 1);
      return return_data == '+' ? data.substring(1, data.length) : data;
    },
    goToWaChat() {
      let msg = `Hello!%20I%20have%20a%20question%20about%20my%20recent%20order.%0A%0A*Invoice%20Number:*%20${
        this.trx.invoice
      }%0A*Customer%20Name:*%20${
        this.trx.session.customer_detail.name
      }%0A*Order%20Date:*%20${this.$formatDateTime(
        this.trx.service_date
      )}%0A%0ACan%20you%20provide%20more%20details%20or%20assistance%3F%0A%0AThanks%20in%20advance!`;
      let url = `https://wa.me/${this.maskingPlusChar(
        this.getMerchant.whatsapp_number
      )}?text=${msg}`;

      this.$openLink(url, '_blank');
    },
    openTrackDelivery() {
      const element = this.$refs.trackDelivery;
      if (element) element.togglePopup(true);
    },
  },
};
</script>
<style>
.top-section-wrapper {
  height: 200px;
  display: grid;
  place-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/restaurant/TrxResult.vue